import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, Provider } from '@angular/core';
import { MSAL_INSTANCE, MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  PublicClientApplication,
  BrowserCacheLocation,
  Configuration,
  IPublicClientApplication
} from '@azure/msal-browser';
import { tryGetActiveMsalSettings } from './utils/msal-config';

const origin = window.location.origin;
const activeMsalSettings = tryGetActiveMsalSettings();

const msalConfig: Configuration | null = activeMsalSettings
  ? {
      auth: {
        clientId: activeMsalSettings.clientId,
        authority: `https://login.microsoftonline.com/${activeMsalSettings.tenantId}`,
        redirectUri: `${origin}/login`,
        postLogoutRedirectUri: `${origin}/login`
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        allowRedirectInIframe: true
      }
    }
  : null;

function isMsalCryptoSupported(): boolean {
  if (!window.isSecureContext) {
    return false;
  }

  const cryptoObj = window.crypto;
  return Boolean(cryptoObj?.subtle && cryptoObj?.getRandomValues);
}

let msalInstance: IPublicClientApplication | null = null;

if (!activeMsalSettings) {
  console.info('[MSAL] Waiting for domain selection before initializing MSAL instance.');
} else if (isMsalCryptoSupported() && msalConfig) {
  msalInstance = new PublicClientApplication(msalConfig);
} else {
  console.warn('[MSAL] Disabled: browser crypto API is unavailable in this context.');
}

const msalProviders: Provider[] = [];

if (msalInstance) {
  msalProviders.push(
    {
      provide: MSAL_INSTANCE,
      useValue: msalInstance
    },
    MsalService,
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => msalInstance!.initialize(),
      multi: true
    },
    {
      provide: MsalBroadcastService,
      useValue: new MsalBroadcastService(msalInstance)
    }
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    ...msalProviders
  ]
}).catch((err) => console.error(err));